import {delegateListener} from '../utils/delegate-listener.js';

const setCollapse = () => {
  const toggleSelector = '[data-collapse][data-target]';
  delegateListener('click', toggleSelector, e => {
    const toggle = e.target.closest(toggleSelector);
    const collapses = document.querySelectorAll(toggle.dataset.target);
    collapses.forEach(collapse => {
      collapse.style.height =
          collapse.clientHeight ? 0 : collapse.scrollHeight + 'px';
      collapse.classList.toggle('expanded', !collapse.clientHeight);
      if (toggle.classList.contains('inner-toggle-btn')) {
        collapse.previousElementSibling.classList.toggle(
            'd-none', !collapse.clientHeight);
      }
      if (!toggle.classList.contains('no-rotate')) {
        toggle.style.transform =
            collapse.clientHeight ? 'rotate(0turn)' : 'rotate(-.5turn)';
      }
    });
  });
};

export {setCollapse};